import UserSection from '../components/UsersSection/UsersSection';

export const UsersPage = () => {
    return <UserSection />;
};
